import React from 'react'
import { ChartsBox } from '../Styles/Shared.styles'
import { MSRCountBoxCompact, Completed } from '../Styles/CompactView.styles'
import { path } from 'ramda'
import { Theme } from '@pga/pga-component-library'

export const PDRCount = ({ completed, total, color }) => (
  <MSRCountBoxCompact color={color}>
    <Completed color={color}>{completed}</Completed> of {total}
  </MSRCountBoxCompact>
)

export default ({ currentPerson }) => {
  const { pdrRequirements } = currentPerson
  const requirements = path(['requirements'], pdrRequirements)
  return (
    <ChartsBox>
      {requirements.map((pdr, index) => (
        <PDRCount key={index} completed={pdr.earned} total={pdr.totalRequirement} color={[Theme.colors.lightBlue, Theme.colors.gold, Theme.colors.primary][index]} />
      ))}
    </ChartsBox>
  )
}
